import React, { Component } from 'react';

export default function CheckBoxIcon () {
	return (
			<svg aria-hidden="true" focusable="false" role="presentation" width="11" height="11" viewBox="0 0 13 13" xmlns="http://www.w3.org/2000/svg">
				<path fill="currentColor" fillRule="evenodd" d="M0,2.00276013 C0,0.896666251 0.893542647,0 2.00276013,0 L10.9972399,0 C12.1033337,0 13,0.893542647 13,2.00276013 L13,10.9972399 C13,12.1033337 12.1064574,13 10.9972399,13 L2.00276013,13 C0.896666251,13 0,12.1064574 0,10.9972399 L0,2.00276013 Z M3.038,6.013 L2,7.024 L5.115,10.061 L11,4.325 L9.962,3.312 L5.115,8.038 L3.038,6.013 Z"></path>
			</svg>
	)
}